import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AuthPasskeyRegisterRequestBody,
  AuthPasskeyRegisterResponse,
} from "./types";

export class AuthPasskeyRegisterAPI extends BaseAPI<
  AuthPasskeyRegisterRequestBody,
  AuthPasskeyRegisterResponse
> {
  protected route = ApiRoutes.auth.passkey_register;
  protected method = RequestMethod.POST;
}
